/** Presentation helper only; API/worker boundaries always resolve current database authority. */
export function userHasModulePermission(user:{modulePermissions?:readonly string[]}|null|undefined,moduleKey:string,permission:string):boolean {
 return /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(moduleKey) && moduleKey.length<=48
  && permission.startsWith(`module.${moduleKey}.`) && /^module\.[a-z0-9-]+\.[a-z][a-z0-9_-]*\.[a-z][a-z0-9_-]*$/.test(permission)
  && Boolean(user?.modulePermissions?.includes(permission));
}
